import styles from './Header.module.less';

function Header(props: { children: any, className?: string }) {
  return <header className={`h-12 bg-primary text-secondary flex items-center px-5 ${props.className}`}>{props.children}</header>;
}

export default Header;
